/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgArrowLinkCurve = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <g fill="none">
      <path
        d="m6 1.586 3.707 3.707-1.414 1.414L7 5.414V8a3 3 0 0 0 3 3h7a5 5 0 0 1 5 5v6h-2v-6a3 3 0 0 0-3-3h-7a5 5 0 0 1-5-5V5.414L3.707 6.707 2.293 5.293z"
        fill="currentcolor"
      />
    </g>
  </Icon>
);
export { SvgArrowLinkCurve as ArrowLinkCurve };
